<script>
import ItemIndex from "../../abstract/ItemIndex.js";

let actualName;

export default ItemIndex.extend({
  props: {
    permissions: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      endpoint: "/api/roles",
      limit: 15,
      sortColumn: "title",
      filteredPermissions: [],
      options: {
        type: "student"
      },
      modal: {
        item: {
          scope_rules: {},
          permissions: []
        }
      },
      default: {
        type: "employee",
        scope_rules: {},
        permissions: []
      },
      messages: {
        remove: {
          title: "Удаление роли",
          message: "Вы действительно хотите удалить данную роль?",
          confirm: "Удалить роль",
          cancel: "Отмена",
          success: "Роль была успешно удалена"
        }
      }
    };
  },
  methods: {
    getPermissions(role) {
      return _.filter(this.permissions, permission => {
        return _.findIndex(role.permissions, p => p.id == permission.id) > -1;
      });
    },
    tryOpen(item) {
      if (item.is_updatable) {
        this.open(item);
      }
    },
    beforeOpen(item) {
      if (!item) {
        return new Promise(resolve => {
          resolve();
        });
      }

      return new Promise((resolve, reject) => {
        item.name = item.title;
        item.is_hidden = item.is_hidden || false;
        item.permissions = _.map(item.permissions, p => {
          return { id: p.id };
        });
        resolve();
      });
    },
    createRole() {
      this.modal.type = this.default.type = "employee";
      this.open();
    },
    createTag() {
      this.modal.type = this.default.type = "tag";
      this.open();
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/roles/Index.vue